// CYA disclaimer — Drew owns the final copy. Single source shared by the PDF
// export footer and the in-app Strategy Story presentation.
export const CYA_TEXT =
  "For illustration purposes only. Not tax, legal, or investment advice. Projections are estimates based on the inputs provided and assumptions about future tax rates, investment returns, and tax law. Actual results will vary. Reach out to your tax advisor before acting on any strategy presented in this report.";

/**
 * The alt fund's own disclosure, shown wherever the fund's cash-flow figures
 * appear on their own (the comparison's "investment on its own" section).
 * Names the exhibit the numbers came from; never the internal legacy label.
 * Draft wording pending counsel review.
 */
export function altFundDisclosure(): string {
  return "These figures are the fund's hypothetical pro forma, not a projection or a guarantee. This is not an offer or solicitation; the Private Placement Memorandum governs. The investment is illiquid and can be lost in full. The deduction depends on the investor's own facts and is subject to IRS review.";
}
